export default __webpack_public_path__ + "static/media/white_mode_back.a325f2fb.svg";